import { useEffect, useState } from 'react'
import { teamsService } from '../../../services/teamsService'
import type { Team } from '../../../types/api.types'

export function useTeams(propertyId: number | undefined): Team[] {
  const [teams, setTeams] = useState<Team[]>([])

  useEffect(() => {
    if (propertyId == null) {
      setTeams([])
      return
    }
    let cancelled = false

    teamsService
      .getAll(propertyId)
      .then((data) => {
        if (!cancelled) setTeams(data)
      })
      .catch(() => {
        if (!cancelled) setTeams([])
      })

    return () => {
      cancelled = true
    }
  }, [propertyId])

  return teams
}
